export abstract class BaseCustomErrorResponse {
  public code: number;
  public message: string;
  public name: string;
  public globalHandler: boolean;

  constructor(init: {code?: number, message?: string, globalHandler?: boolean} = {}) {
    this.code = init.code;
    this.message = init.message;
    this.globalHandler = init.globalHandler;
  }
}

export class CustomErrorResponse extends BaseCustomErrorResponse {
}

export class SessionExpiredErrorResponse extends BaseCustomErrorResponse {
}

export class MaintenanceErrorResponse extends BaseCustomErrorResponse {
}

export class CustomErrorPageResponse extends BaseCustomErrorResponse {
}

export class DetailProductErrorResponse extends BaseCustomErrorResponse{
}

export class ActivationProductErrorResponse extends BaseCustomErrorResponse{
}
